export default {
    ACCEPT: 'Кабыл алуу',
    ACCEPT_ADDITIONAL_AGREEMENT: 'Кошумча келишимди кабыл алыңыз',
    ACCEPT_APPLICATION: 'Өтүнмөнү кабыл алуу',
    ACCEPT_DOCUMENT: 'Документти кабыл алуу',
    ACCEPT_RETURN_ACTION: '"Оңдоо үчүн кайтаруу" кабыл алуу',
    ACCEPTED: 'Кабыл алынган',
    ACCEPTED_THE_APPLICATION: '<span class="font-medium">:author</span> арызды кабыл алды',
    ACCESS_DENIED: 'Кирүү четке кагылды',
    ACCESS_DENIED_DESCRIPTION: 'Кечиресиз, сизде бул баракка кирүүгө уруксатыңыз жок.',
    ACCOUNT_NUMBER: 'Эсеп номуру',
    ACCOUNTANT: 'Бухгалтер',
    ACTION: 'Иш-аракет',
    ACTIONS: 'Иш-аракеттер',
    ACTION_REASON: 'Сураныч, иш-аракеттин себебин сүрөттөп бериңиз',
    ACTIVATION_CODE: 'Активдештирүү коду',
    ACTIVATION_CODE_SENT_TO_TELEGRAM: 'Активдөө коду сизге телеграмда жөнөтүлдү',
    ACTIVATION_TELEGRAM: 'Телеграмды активдештирүү',
    ADD: 'Кошуу',
    ADD_ADDRESS: 'Дарек кошуу',
    ADD_ANSWER: 'Жооп кошуу',
    ADD_CERTIFICATE_OR_LICENSE_FILE: 'Сертификат же лицензия файлын кошуңуз',
    ADD_EMPLOYMENT: 'Кызматкерди кошуу',
    ADD_EXECUTOR: 'Кызматкерди кошуу',
    ADD_EXECUTORS: 'Кызматкерлерди кошуу',
    ADD_FILE: 'Файл кошуу',
    ADD_FILES: 'Файлдарды кошуу',
    ADD_INDICATORS: 'Индикаторлорду кошуу',
    ADD_SIGNERS: 'Кол коюуучуларды кошуу',
    ADD_TELEGRAM_USER_ID: 'Телеграм "user ID" кошуу',
    ADDED_AS_A_SIGNER_TO_RESOLUTION: '<span class="font-medium">:employee</span> токтомго макулдашуучу болуп дайындалды',
    ADDED_AS_AN_EXECUTOR_TO_RESOLUTION: '<span class="font-medium">:employee</span> токтомго аткаруучу болуп дайындалды',
    ADDED_TO_APPLICATION: '<span class="font-medium">:employee</span> арызга кошулду',
    ADDING_AN_ADDRESS: 'Дарек кошуу',
    ADDING_CUSTOMER_INFORMATION: 'Кардар маалыматын кошуу',
    ADDING_DOCUMENTS: 'Документтерди кошуу',
    ADDITIONAL_AGREEMENT: 'Кошумча келишим',
    ADDITIONAL_AGREEMENT_SHORT: 'КК',
    ADDITIONAL_EXPERTISE: 'Кошумча экспертизанын түрлөрү',
    ADDITIONAL_FILE: 'Кошумча файл',
    ADDITIONAL_FILES: 'Кошумча файлдар',
    ADDITIONAL_TERMS_OF_THE_PARTIES: 'Тараптардын кошумча шарттары',
    ADDRESS: 'Дарек',
    ADMINISTRATOR: 'Администратор',
    AGREED: 'Макулдаштыруучу',
    AGREEDS: 'Макулдаштыруучулар',
    AGREEMENT: 'Келишим',
    AGREEMENT_CREATE: 'Келишим түзүү',
    AGREEMENT_DATE_AND_TIME: 'Келишимдин датасы жана убактысы',
    AGREEMENT_DEADLINE: 'Келишимдин мөөнөтү',
    AGREEMENT_EDIT: 'Келишимди түзөтүү',
    AIMAK: 'Аймак',
    ALL: 'Баары',
    ALSO_MAIN_CUSTOMER: 'Негизги кардар катары коюу',
    ANSWER: 'Жооп',
    ANSWER_CONFIRM: 'Жоопко макул',
    ANSWER_TYPE: 'Жооп түрү',
    ANSWERED: 'Жооптор',
    ANSWERED_TO_RESOLUTION: '<span class="font-medium">:author</span> токтомго жооп кайтарды',
    ANSWERS: 'Жооптор',
    APP_NAME: 'Гос строй',
    APPLICANT: 'Арыз берүүчү',
    APPLICANT_CONSTRUCTOR: 'Арыз берүүчү/Проектировщик',
    APPLICANT_DATA: 'Арыз берүүчүнүн чоо-жайы',
    APPLICANT_INFORMATION: 'Арыз берүүчү жөнүндө маалымат',
    APPLICANT_INFORMATION_CREATE: 'Арыз берүүчү жөнүндө маалымат түзүү',
    APPLICANT_INFORMATION_EDIT: 'Арыз берүүчү жөнүндө маалымат түзөтүү',
    APPLICANT_PATRONYMIC: 'Арыз берүүчүнүн/проектировщиктин атасынын аты (отчество)',
    APPLICANT_SURNAME: 'Арыз берүүчүнүн/проектировщиктин фамилиясы',
    APPLICATION: 'Арыз',
    APPLICATION_ACCEPTED: 'Арыз кабыл алынды',
    APPLICATION_CREATE: 'Арыз түзүү',
    APPLICATION_EDIT: 'Арызды түзөтүү',
    APPLICATION_IS_NOT_GENERATED: 'Колдонмо түзүлгөн жок',
    APPLICATION_NEXT_STATUS: 'Колдонмонун кийинки статусу',
    APPLICATION_NUMBER: 'Өтүнмөнүн номери',
    APPLICATION_SENT_TO_EXPERTIZE: 'Өтүнмө кароого жөнөтүлдү!',
    APPLICATION_STATUS: 'Колдонмо статусу',
    APPLICATION_STATUSES: 'Колдонмо статустары',
    APPLICATIONS: 'Арыздар',
    APPLICATIONS_LIST_EMPTY: 'Колдонмо тизмеси бош',
    APPLICATIONS_LIST_TITLE: 'Арыздар',
    APPOINTMENT: 'Объекттин максаты',
    ARE_YOU_SURE_TO_DELETE: 'Чын эле жок кылгыңыз келеби?',
    ARE_YOU_SURE_TO_RESET_DEFAULT_SETTINGS: 'Чын эле демейки жөндөөлөрдү баштапкы абалга келтиргиңиз келеби?',
    ASSIGN: 'Дайындоо',
    ASSIGN_CLOSING_SIGNER: 'Коштомо жазууну дайындаңыз',
    ASSIGN_ACCOUNTANT: 'Бухгалтерди дайындаңыз',
    ASSIGN_CURATOR: 'Бөлүм кураторун дайындоо',
    ASSIGN_PAYER: 'Төлөөчүнү дайындоо',
    ASSIGN_RESPONSIBLE: 'Жоопкерчиликтүүнү дайындоо',
    ASSIGNED_AS_A_CURATOR_TO_RESOLUTION: '<span class="font-medium">:employee</span> токтомго куратор болуп дайындалды',
    ASSIGNED_AS_A_RESPONSIBLE_TO_RESOLUTION: '<span class="font-medium">:employee</span> токтомго жоопкерчиликтүү болуп дайындалды',
    ATTACH_ADDITIONAL_AGREEMENT: 'Кошумча келишимди тиркеңиз',
    ATTACH_CONFIRMATION_DOCUMENT: 'Коштоочу документти тиркеңиз ',
    ATTACH_CORRECTION_LETTER: 'Мүчүлүштүктөрдү оңдоо катын тиркеңиз',
    ATTACH_FILE: 'Файлды тиркөө',
    ATTACH_FILES: 'Файлдарды тиркөө',
    ATTACH_PAYMENT_ORDER: 'Төлөм тапшырмасын тиркеңиз',
    ATTACHED_FILES: 'Тиркелген файлдар',
    ATTENTION: 'Көңүл бургула!',
    ATTENTION_DESCRIPTION: 'Тиркемени түзүү үчүн профилиңизди толук толтуруу керек',
    AUTHENTICATION: 'Авторизация',
    AUTHOR: 'Автор',
    AVATAR: 'Аватар',
    BACK: 'Артка',
    BANK_DATA: 'Банктын маалыматтары',
    BANK_DETAILS: 'Банк реквизиттери',
    BANK_NAME: 'Банктын аталышы',
    BASIS_FOR_ADDITIONAL_AGREEMENTS: 'Кошумча корутунду үчүн негиз. келишимдер',
    BIK: 'БИК',
    BIRTH_DATE: 'Туулган күнү',
    BLOCKING: 'Кулпу',
    BY_CLICKING_START_BUTTON: '"start" баскычын басуу менен',
    BY_DATE_OF_RECEIPT: 'Кабыл алуу датасы боюнча',
    BY_DATE_OF_REGISTRATION: 'Каттоо датасы боюнча',
    BY_DATE_OF_EXECUTION: 'Аткаруу датасы боюнча',
    BRANCH: 'Филиал',
    CALCULATION_OF_THE_TOTAL_AMOUNT: 'Жалпы сумманы эсептөө',
    CALCULATOR: 'Калькулятор',
    CANCEL: 'Жокко чыгаруу',
    CATEGORY: 'Категория',
    CERTIFICATE_NUMBER: 'Сертификаттын номери',
    CERTIFICATE_NUMBER_LICENSES: 'Сертификат/Лицензия номери',
    CERTIFYING_DOCUMENTS: 'Правоудостоверяющие документы',
    CERTIFYING_ESTABLISHING_DOCUMENTS: 'Правоудостоверяющие документы/Правоустанавливающие документы',
    CHANGE_IN_PROCESS_REJECTED: 'Иштөө тартибинде өзгөртүү четке кагылды',
    CHANGE_REASON: 'Өзгөртүүнүн себеби',
    CHANGE_REJECTED: 'Өзгөртүү четке кагылды',
    CHANGE_REQUEST: 'Өзгөртүү өтүнүчү',
    CHAPTER: 'Бөлүм',
    CHECK_EMAIL_FOR_PASSWORD_RESET: 'Электрондук почтаңызды текшерип, улантуу үчүн биз жөнөткөн шилтемени ачыңыз',
    CHILDREN_ANSWERS: 'Кыскача жооптор',
    CHOOSE_FILE: 'Файлды тандоо',
    CHOOSE_FILES: 'Файлдарды тандоо',
    CITIZENSHIP: 'Жарандык',
    CIVIL: 'Мамлекетик',
    CLOSE: 'Жабуу',
    CLOSED_THE_RESOLUTION: '<span class="font-medium">:author</span> токтомду жапты',
    CLOSING_SIGNER: 'Жабуучу кол коюу',
    CLOSING_SIGNER_SHORT: 'Ж',
    CODE: 'Коду',
    CODE_OF_BANK_REQUISITE: 'Банк реквизиттеринин коду',
    COMMENTS: 'Комментарийлер',
    COMPLETED: 'Аякталды',
    COMPLETION: 'Аяктоо',
    CONCLUSION: 'Корутунду',
    CONCLUSION_NUMBER: 'Корутунду номери',
    CONFIDANT: 'Ишенимдүү адам',
    CONFIDANT_INFORMATION_CREATE: 'Ишенимдүү адамды кошуңуз',
    CONFIDANT_INFORMATION_EDIT: 'Ишенимдүү адамды түзөтүңүз',
    CONFIRM: 'Ырастоо',
    CONFIRM_PASSWORD: 'Сырсөздү кайталаңыз',
    CONFIRM_PAYMENT: 'Төлөмдү ырастоо',
    CONFIRMED: 'Ырасталды',
    CONFIRMED_THE_RESOLUTION_ANSWER: '<span class="font-medium">:author</span> токтомдун жообуна макулдугун берди',
    CONSTRUCTION_TYPE: 'Курулуштун түрү',
    CONSTRUCTOR: 'Проектировщик',
    CONSTRUCTOR_DATA: 'Дизайнер маалыматтары',
    CONTACT_DETAILS: 'Байланыш маалыматтары',
    CONTACTS: 'Байланыштар',
    CONTACTS_DATA: 'Байланыш маалыматтары',
    CONTRACT_SUBJECT: 'Макулдашуунун предмети',
    COPY_USER_ID_HERE: 'user ID бул жерге көчүрүңүз',
    CORRECTION_LETTER: 'Оңдоо кат',
    COST_CALCULATION: 'Чыгымды эсептөө',
    CREATE: 'Түзүү',
    CREATE_ACCOUNT: 'Аккаунт түзүү',
    CREATION_DATE: 'Түзүлгөн күнү',
    CREATION_DATE_FROM: 'Түзүлгөн күнү (баштап)',
    CREATION_DATE_TO: 'Түзүлгөн күнү (чейин)',
    CURATOR: 'Куратор',
    CURATOR_SHORT: 'К',
    CUSTOMER: 'Кардар',
    CUSTOMER_CONTACT_EMAIL: 'Кардардын электрондук почта дареги',
    CUSTOMER_CONTACT_NAME: 'Кардардын байланыш аты',
    CUSTOMER_CONTACT_PATRONYMIC: 'Кардар менен байланышуучунун аты-жөнү',
    CUSTOMER_CONTACT_PHONE: 'Кардардын телефон номери',
    CUSTOMER_CONTACT_PHONE_WORK: 'Кардардын жумуш телефон номери',
    CUSTOMER_CONTACT_SURNAME: 'Кардар менен байланышуучунун аты',
    CUSTOMER_DATA: 'Кардар маалыматтары',
    CUSTOMER_INFORMATION: 'Долбоордун кардары жөнүндө маалымат',
    CUSTOMER_INFORMATION_CREATE: 'Долбоордун кардары жөнүндө маалыматын түзүү',
    CUSTOMER_INFORMATION_EDIT: 'Долбоордун кардары жөнүндө маалыматты түзөтүү',
    CUSTOMER_IS_APPLICANT: 'Кардар арыз берүүчү',
    CUSTOMER_NAME: 'Кардардын аты',
    CUSTOMER_OWNER: 'Чынында, мен бул долбоордун кардарымын',
    CUSTOMER_PROJECT: 'Долбоордун кардары',
    CUSTOMERS_EDIT_WARNING: 'Түзөтүү үчүн эскертүү',
    DATA_TYPE_ERROR: 'Маалымат түрү катасы',
    DATE: 'Дата',
    DATE_OF_ISSUE: 'Берилген күнү',
    DEADLINE: 'Мөөнөтү',
    DELETE: 'Жок кылуу',
    DENOMINATION: 'Аталышы',
    DEPARTMENT: 'Бөлүм',
    DEPARTMENT_CURATOR: 'Бөлүм куратору',
    DEPARTMENT_RESPONSIBLE: '«Ж» белумунун аткаруучусу',
    DEPARTMENTS: 'Бөлүмдөр',
    DETAIL: 'Толук маалымат',
    DESIGNER_DEVELOPER: 'Дизайнер/Иштеп чыгуучу',
    DIRECTOR: 'Директор',
    DISTRIBUTION: 'Бөлүштүрүүлөр',
    DISTRICT: 'Район',
    DOCUMENT: 'Документ',
    DOCUMENT_APPLICANT_SELF_OWNER: 'Чынында, мен бул долбоордун дизайнеримин',
    DOCUMENT_CREATE: 'Документти түзүү',
    DOCUMENT_DENOMINATION: 'Документтин аты',
    DOCUMENT_EDIT: 'Документти түзөтүү',
    DOCUMENT_HISTORY: 'Документ тарыхы',
    DOCUMENT_NUMBER: 'Документ №',
    DOCUMENT_REMARKS: 'Документтин эскертүүлөрү',
    DOCUMENT_TYPE: 'Документтин түрү',
    DOCUMENTS: 'Документтер',
    DOCUMENTS_CREATE: 'Документтерди түзүү',
    DOCUMENTS_EDIT: 'Документтерди түзөтүү',
    DOCUMENTS_LIST_EMPTY: 'Документ жок',
    DOCUMENTS_VERSION: 'Документтердин версиясы',
    DOWNLOAD: 'Жүктөп алуу',
    DOWNLOAD_FILES: 'Файлдарды жүктөө',
    EDIT: 'Түзөтүү',
    EDIT_ADDRESS: 'Даректи түзөтүү',
    EDIT_PERSONAL_DATA: 'Жеке маалыматтарды түзөтүү',
    EDIT_REMARKS: 'Эскертүүнү түзөтүү',
    EGRZ: 'ЕГРЗ Арыздар',
    EMAIL: 'Электрондук почта',
    EMAIL_SENT: 'Электрондук кат жөнөтүлдү',
    EMPLOYEE: 'Кызматкер',
    EMPLOYEES: 'Кызматкерлер',
    EMPTY: 'Бош',
    ENTER: 'Толтурунуз',
    ENTER_CONCLUSION_NUMBER: 'Корутунду номерин киргизиңиз',
    ENTER_EMAIL: 'Электрондук почтаны киргизиңиз',
    ENTER_PASSWORD: 'Сырсөздү киргизиңиз',
    ENTER_PIN_FOR_CLOUD_SIGN: 'Электрондук кол коюу үчүн PIN кодду киргизиңиз',
    ENTER_PROJECT_DENOMINATION: 'Арыздын аталышын киргизиңиз',
    ENTER_YOU_PIN: '14 орундуу PIN кодуңузду киргизиңиз',
    ENTER_REASON: 'Себебин киргизиңиз',
    ENTITLEMENT_DOCUMENTS: 'Правоустанавливающие документы',
    EXCLUDING_TAXES: 'салыктарды кошпогондо',
    EXECUTOR_NAME: 'Аткаруучунун аты',
    EXECUTOR_PATRONYMIC: 'Аткаруучунун атасынын аты',
    EXECUTOR_SURNAME: 'Аткаруучунун фамилиясы',
    EXECUTORS: 'Аткаруучулар',
    EXPERT_OBJECT: 'Экспертизанын объектиси',
    EXPERT_TYPE: 'Экспертизанын түрү',
    EXPERTIZE: 'Экспертиза',
    EXPERTIZE_DEADLINE: 'Экспертизанын мөөнөтү',
    EXPERTIZE_PAYMENT_SOURCE: 'Экспертиза үчүн төлөм булагы',
    EXPIRATION_DATE: 'Жарамдык датасы',
    EXTRABUDGETARY_FUNDS: 'Бюджеттен тышкаркы фонддор',
    FACILITY_INFORMATION: 'Объект боюнча маалымат',
    FACILITY_INFORMATION_CREATE: 'Объект боюнча маалымат түзүү',
    FACILITY_INFORMATION_EDIT: 'Объект боюнча маалыматы түзөтүү',
    FAMILIARIZE: 'Таанышты',
    FILE: 'Файл',
    FILE_CERTIFICATE_LICENSES: 'Сертификат/Лицензия файлы',
    FILES: 'Файлдар',
    FILL_PROFILE: 'Профилиңизди толтуруңуз',
    FIND: 'Табуу',
    FIRST_FILL_PREVIOUS_STEPS: 'Алгач мурунку кадамдарды бүтүрүңүз',
    FLOOR: 'Кабат',
    FOR_SIGN: 'Кол коюуда',
    FORGOT_PASSWORD: 'Сыр сөзүңүздү унуттуңузбу?',
    FOOTER_DESCRIPTION: 'Түшүндүрмө',
    FROM_APPLICANT: 'Атынан',
    FROM_APPLICANT_HINT_TEXT: '<p class="mb-2">Необходимо продолжить текст и ввести для: ' + '<br/>' +
        '- физических лиц и ИП И.О. Фамилию (в родительном падеже)' + '<br>' +
        '- юридических лиц ввести должность (в родительном падеже), наименование организации и И.О. Фамилию (в родительном падеже).' +
        '</p>' +
        '<p>Пример отображения после заполнения:</p>' +
        '<p class="italic">' +
        '«Мы, нижеподписавшиеся, Департамент государственной экспертизы в лице директора  Асанов А.А., действующего на основании Положения, именуемый в дальнейшем «Исполнитель» с одной стороны, и директора ОАО «Солнечный» в лице Т.А. Асанова, именуемый в дальнейшем «Заказчик», с другой стороны, заключили настоящий договор…»' +
        '</p>',
    FROM_APPLICANT_TEXT: 'Мы, нижеподписавшиеся, Департамент государственной экспертизы в лице директора Ф.И.О, действующего на основании Положения, именуемый в дальнейшем «Исполнитель» с одной стороны, и ',
    FROM_APPLICANT_POSITION_FULLNAME: 'Атынан (кызмат орду жана аты-жөнү)',
    FROM_WHOM: 'Кимден',
    FULL_NAME: 'ФИО',
    GENERAL_INFORMATION: 'Жалпы маалымат',
    GENERAL_REPORT: 'Жалпы отчет',
    GENERAL_REPORT_BY_REGIONS: 'Аймактар боюнча жалпы отчет',
    GENERAL_REPORT_BY_OBJECT_TYPES: 'Объекттин түрлөрү боюнча жалпы отчет',
    GENERATE: 'Түзүү',
    GENERATE_FILE: 'Файлды түзүү',
    GENERATE_APPLICATION_AND_SIGN: 'Тиркемени түзүү жана кол коюу',
    GENERATED_AGREEMENT: 'Түзүлгөн келишим',
    GENERATED_APPLICATION: 'Түзүлгөн арыз',
    GET_TELEGRAM_USER_ID: 'Телеграм "user ID" алуу',
    GO_BACK: 'Артка кайтуу',
    GO_BACK_TO_RESOLUTIONS: 'Резолюцияларга кайтуу',
    GOV_ORGANIZATION: 'Госорган',
    HAVE_A_PROFILE_LOGIN: 'Профиль барбы? Кирүү',
    HEADING: 'Баш макала',
    HIDE_FILE: 'Файлды жашыр',
    HISTORY: 'Тарых',
    HOUSE: 'Үй',
    IN_PROCESS: 'Аткарылууда',
    IN_PROCESS_REMARK: 'Иштөө тартибинде эскертүүлөр',
    IN_PROCESS_REMARK_WARNING: 'Сиз ишенесизби? "Сактоо" баскычын басуу менен сиздин комментарийиңиз арыз ээси үчүн жеткиликтүү болот',
    INBOX: 'Кирүүчү',
    INBOXES: 'Кирүүчү куту',
    INDICATOR_DESIGNATION: 'Индикатордун белгилениши',
    INDIVIDUAL_ENTERPRISE_CODE: 'Жеке ишкердин коду',
    INDIVIDUAL_ENTERPRISE_FIRST_REGISTER_DATE: 'Алгачкы каттоо датасы',
    INDIVIDUAL_ENTERPRISE_LAST_REGISTER_DATE: 'Акыркы кайра каттоонун датасы',
    INDIVIDUAL_ENTERPRISE_LEGAL_FORM: 'Уюштуруу-укуктук формасы',
    INDIVIDUAL_ENTERPRISE_REGISTER_NUMBER: 'Каттоо номери',
    INDIVIDUAL_ENTERPRISE_TAX_CODE_NAME: 'Салык органынын коду жана аталышы',
    INDIVIDUAL_ENTITY: 'Жеке адам',
    INDIVIDUAL_ENTREPRENEUR: 'Жеке ишмер',
    INFORMATION: 'Маалымат',
    INFORMATION_ABOUT_CUSTOMER: ' Долбоордун кардары жөнүндө маалымат',
    INFORMATION_ABOUT_THE_CUSTOMER_OF_THE_PROJECT: 'Долбоордун кардары жөнүндө маалымат',
    INFORMATION_ABOUT_THE_APPLICANT_DESIGNER: 'Өтүнмө ээси/дизайнер жөнүндө маалымат',
    INFORMATION_ABOUT_THE_OBJECT: 'Объект жөнүндө маалымат',
    INITIAL_DATA: 'Кыска маалымат',
    INITIAL_PERMIT_DOCUMENTATION: 'Баштапкы уруксат документтери',
    INN: 'ИНН',
    INN_PIN: 'ИНН/ПИН',
    INVOICE_FOR_PAYMENT: 'Төлөө үчүн эсеп-дүмүрчөк',
    IS_OWNER: 'Чынында, мен бул долбоордун кардарымын',
    ISSUED_BY: 'Берүүчү орган',
    ISSUED_DATE: 'Берилген күнү',
    KG: 'KG',
    KYRGYZ: 'Кыргызча',
    LAST_SELECTED_EMPLOYEES: 'Акыркы тандалган кызматкерлер',
    LAWYER: 'Юрист',
    LEADS: 'Сводящие',
    LEGAL_ENTITY: 'Юридикалык жак',
    LETTER_FILE: 'Кат файлы',
    LIST_EMPTY: 'Тизме бош',
    LOCATION_CATEGORY: 'Объект категориясы',
    LOCATION_TYPE: 'Объект түрү',
    LOGIN: 'Логин',
    LOGIN_AS_EMPLOYEE: 'Кызматкер катары кириңиз',
    LOGOUT: 'Чыгуу',
    MAIN_BANK_ACCOUNT: 'Негизги учурдагы эсеп',
    MAIN_CUSTOMER: 'Негизги кардар',
    MAIN_CUSTOMER_SIGN_PENDING: 'Негизги кардар тарабынан кол коюу күтүлүүдө',
    MAIN_INFORMATION: 'Негизги маалымат',
    MAIN_STATUS: 'Негизги статус',
    MAIN_TECHNO_ECONOMIC_INDICATORS_OF_OBJECT: 'КС объектинин негизги техникалык-экономикалык көрсөткүчтөрү',
    MAIN_TECHNO_ECONOMIC_INDICATORS_OF_OBJECT_CREATE: 'КС объектинин негизги техникалык-экономикалык көрсөткүчтөрүн түзүү',
    MAIN_TECHNO_ECONOMIC_INDICATORS_OF_OBJECT_EDIT: 'КС объектинин негизги техникалык-экономикалык көрсөткүчтөрүн түзөтүү',
    MANAGER: 'Менеджер',
    MANUAL: 'Справочник',
    MARK_AS_READ: 'Окулган деп белгилөө',
    MESSAGE: 'Кабар',
    MIDDLE_NAME: 'Атасынын аты (Отчество)',
    MORE: 'Дагы',
    MUNICIPAL: 'Муниципалдык',
    MY_APPLICATIONS: 'Менин арыздарым',
    NAME: 'Аты',
    NAME_OF_CALCULATION: 'Эсептөө объектинин аталышы',
    NDS: 'НДС',
    NEED_TO_PASS_EXTRA_TYPES_OF_EXPERTIZE: 'Экзамендердин кошумча түрлөрүн тапшыруу керекпи?',
    NEGATIVE_ANSWER: 'Терс жооп',
    NEW_APPLICATION: 'Жаңы билдирүү',
    NEXT: 'Андан ары',
    NEXT_STATUS: 'Кийинки абалы',
    NO: 'Жок',
    NO_FILE_CHOSEN: 'Файл тандалган жок',
    NO_PROFILE_REGISTER: 'Профилиңиз жокпу? Каттоо',
    NOT_CONFIRMED: 'Тастыкталган эмес',
    NOT_FOUND: 'Табылган жок',
    NOTIFICATIONS: 'Эскертмелер',
    NOTIFICATIONS_EMPTY: 'Азырынча билдирмелер жок',
    NSP: 'НСП',
    NUMBER: 'Номер',
    OBJECT_CATEGORY: 'Объект категориясы',
    OBJECT_EXPERTIZE: 'Объект экспертизы',
    OBJECT_INDICATORS: 'Объектинин көрсөткүчтөрү',
    OBJECT_IS_STRATEGIC: 'Курулуш аянтчасынын стратегиялык мааниси барбы?',
    OBJECT_NAME: 'Объекттин аты',
    OBJECT_POSTAL_ADDRESS: 'Капиталдык курулуш объектинин почталык (курулуш) дареги',
    OBJECT_TYPE: 'Объект түрү',
    OKPO: 'ОКПО',
    ON_CONFIRM: 'Кароодо',
    ON_PENDING: 'Күтүүдө',
    ON_DISABILITY: 'Ооруу өргүүсү :start баштап, :end чейин',
    ON_TRIP: 'Командировка :start баштап, :end чейин',
    ON_VACATION: 'Отпуск :start баштап, :end чейин',
    ORG_CHIEF_NAME: 'Уюмдун жетекчисинин аты-жөнү',
    ORG_CHIEF_PATRONYMIC: 'Уюмдун жетекчисинин атасынын аты',
    ORG_CHIEF_SURNAME: 'Уюмдун жетекчисинин фамилиясы',
    ORG_NAME: 'Компаниянын аты',
    ORG_NAME_KG: 'Компаниянын аты (kg)',
    ORG_NAME_RU: 'Компаниянын аты (ru)',
    ORGANIZATION_CHIEF_INN:'Жетекчинин ПИНи',
    ORGANIZATION_CHIEF_NAME:'Жетекчинин аты',
    ORGANIZATION_CHIEF_PATRONYMIC:'Жетекчинин атасынын аты',
    ORGANIZATION_CHIEF_SURNAME:'Жетекчинин фамилиясы',
    ORGANIZATION_FIRST_REGISTER_DATE: 'Алгачкы каттоо датасы',
    ORGANIZATION_FOREIGN_INFO:'Чет өлкөлүк катышуу жөнүндө маалымат',
    ORGANIZATION_LEGAL_FORM:'Уюштуруу-укуктук формасы',
    ORGANIZATION_LEGAL_UNIT_CODE: 'Юридикалык жактын коду',
    ORGANIZATION_LAST_REGISTER_DATE: 'Акыркы кайра каттоонун датасы',
    ORGANIZATION_NAME_KG:'Мамлекеттик тилде толук аталышы',
    ORGANIZATION_NAME_RU:'Толук аты-жөнү расмий тилде',
    ORGANIZATION_OKPO:'ОКПО коду',
    ORGANIZATION_REGISTER_NUMBER:'Каттоо номери',
    ORGANIZATION_SHORT_NAME_KG:'Мамлекеттик тилде кыскартылган аталышы',
    ORGANIZATION_SHORT_NAME_RU:'Расмий тилде кыскартылган аталышы',
    ORGANIZATION_ADDRESS:'Юридикалык жактын, филиалдын (өкүлчүлүктүн) дареги (жайгашкан жери) жөнүндө маалымат',
    OTHER: 'Башка',
    OWNERSHIP_FORM: 'Менчиктин түрү',
    PASSPORT_DATA: 'Паспорттун реквизиттери',
    PASSPORT_INFO: 'Паспорт маалыматтары',
    PASSPORT_NUMBER: 'Паспорттун номери',
    PASSPORT_SERIAL: 'Серия',
    PASSWORD: 'Сырсөз',
    PASSWORD_CONTAINS: 'Сырсөз кеминде 5 белгиден турушу керек: латын тамгалары (кеминде 1 баш) жана кеминде 1 сан',
    PASSWORD_LENGTH: 'Сураныч, 5 символдон ашык сырсөз киргизиңиз',
    PASSWORD_MUST_MATCH: 'Сырсөздөр дал келиши керек',
    PASSWORD_REPEAT: 'Сырсөздү кайталаңыз',
    PASSWORD_RESET: 'Сырсөз өзгөртүлдү',
    PATRONYMIC: 'Атасынын аты (отчество)',
    PAY: 'Төлө',
    PAYER: 'Төлөөчү',
    PAYMENT: 'Төлөм',
    PAYMENT_CONFIRMED: 'Төлөм ырасталды',
    PAYMENT_CHANGE_REQUEST: 'Төлөмдү өзгөртүү өтүнүчү',
    PAYMENT_GENERATED: 'Төлөм түзүлдү',
    PAYMENT_HISTORY: 'Төлөм тарыхы',
    PAYMENT_NOT_CALCULATED_YET: 'Төлөм эсептеле элек',
    PAYMENT_NOT_REQUIRED: 'Төлөм талап кылынбайт',
    PAYMENT_ON_SIGN: 'Төлөм кол коюуда',
    PAYMENT_ORDER: 'Төлөм тапшырмасы',
    PAYMENT_STATUS: 'Төлөм абалы',
    PAYMENT_TYPE: 'Төлөө ыкмасы',
    PENDING_CONFIRM: 'Ырастоону күтүүдө',
    PERMISSION_DENIED: 'Кирүү четке кагылды',
    PERMISSION_REQUEST: 'Кирүү өтүнүчү',
    PERSONAL_DATA: 'Жеке маалыматтар',
    PERSONAL_DATA_AGREEMENT: 'Мен жеке маалыматтарымдын иштетилүүсүнө макулмун',
    PERSONAL_DATA_AUTHENTICITY: 'Мен толтурган маалыматтардын тууралыгын жана берилген документтердин аныктыгын ырастайм',
    PERSONAL_DATA_PERMISSION_FORM: 'Жеке маалыматтарды иштетүүгө макулдуктун формасы',
    PERSONAL_DATA_UPDATED_SUCCESSFULLY: 'Профиль ийгиликтүү жаңыртылды!',
    PHONE: 'Телефон',
    PIN: 'Пин',
    PLANNER: 'Проектировщик',
    PLANNER_INFORMATION: 'Дизайнер жөнүндө маалымат',
    PLANNER_INFORMATION_CREATE: 'Дизайнер жөнүндө маалымат түзүү',
    PLANNER_INFORMATION_EDIT: 'Дизайнер жөнүндө маалымат түзөтүү',
    PLOT: 'Участок',
    POSITION: 'Жумуштун аталышы',
    POSITIONS: 'Позициялар',
    POSITIVE_ANSWER: 'Позитивдүү жооп',
    PREVIEW: 'Көрүү',
    PRESENTED_DATA: 'Кароого сунуш кылды',
    PRIVATE: 'Жеке',
    PROFILE: 'Профиль',
    PROJECT_DENOMINATION: 'Долбоордун аталышы',
    PROJECT_MAIN_ARCHITECT: 'Долбоордун башкы архитектору (ДБА)',
    PROJECT_MAIN_ARCHITECT_CREATE: 'Долбоордун башкы архитекторун (ДБА) түзүү',
    PROJECT_MAIN_ARCHITECT_EDIT: 'Долбоордун башкы архитекторун (ДБА) түзөтүү',
    PROJECT_MAIN_ENGINEER: 'Долбоордун башкы инженери (ДБИ)',
    PROJECT_MAIN_ENGINEER_CREATE: 'Долбоордун башкы инженерин (ДБИ) түзүү',
    PROJECT_MAIN_ENGINEER_EDIT: 'Долбоордун башкы инженерин (ДБИ) түзөтүү',
    PROJECT_NAME: 'Курулуш объектинин (долбоордун) аталышы (АГЗдегидей)',
    PROJECT_USERS: 'Долбоордун колдонуучулары',
    PURPOSE_OF_OBJECT: 'Объекттин максаты',
    PURPOSE_OF_OBJECT_TYPE: 'Объекттин түрү',
    REASON: 'Себеп',
    REASSIGN: 'Кайра дайындоо',
    REASSIGN_EMPLOYEE: 'Кызматкерди кайра дайындоо',
    REASSIGN_PAYER: 'Төлөөчүнү кайра дайындоо',
    RECEIPT: 'Квитанция',
    RECEIPT_DATE: 'Алуу күнү',
    REFUSE: 'Баш тартуу',
    REFUSE_APPLICATION: 'Колдонмону четке кагуу',
    REFUSE_DOCUMENT: 'Документти четке кагуу',
    REFUSED: 'Четке кагылды',
    REFUSED_THE_APPLICATION: '<span class="font-medium">:author</span> арызды четке какты',
    REGENERATE_APPLICATION: 'Арызды кайрадан түзүү',
    REGION: 'Область/Шаар',
    REGISTER: 'Каттоо',
    REGISTRATION_ACCESS_REGISTRATION_COMPLETED_SUCCESSFULLY: 'Каттоо ийгиликтүү аяктады',
    REGISTRATION_CONFIRM_EMAIL_TEXT: 'Кирүү үчүн электрондук почтаңызды ырастаңыз, шилтеме каттоодо көрсөтүлгөн электрондук почта дарегиңизге жөнөтүлөт.',
    REGISTRATION_DATE: 'Катталуу күнү',
    REGISTRATION_DATE_FROM: 'Каттоо датасы (баштап)',
    REGISTRATION_DATE_TO: 'Каттоо датасы (чейин)',
    REJECT: 'Четке кагуу',
    REJECT_CHANGE: 'Өзгөртүүнү четке кагуу',
    REJECTED: 'Четке кагылды',
    REJECTION_REASON: 'Баш тартуунун себеби',
    REMARK: 'Эскертүү',
    REMARKS: 'Эскертүү',
    REMARKS_CORRECTION: 'Проблемаларды оңдоо',
    REPEATED_EXPERTIZE: 'Кайра текшерүү',
    REPORT_BY_EMPLOYEE: 'Кызматкерлер боюнча отчет',
    REPORTS: 'Отчеттор',
    REPORTS_TYPE: 'Отчеттун түрү',
    REQUEST_DATE: 'Сурам датасы',
    REQUEST_PROCESSED: 'Өтүнүч иштелип чыккан',
    RESEND: 'Кайра дайындоо',
    RESET: 'Калыбына келтирүү',
    RESET_DEFAULT_SETTINGS: 'Баштапкы абалга келтирүү',
    RESOLUTION: 'Резолюция',
    RESOLUTION_TYPE: 'Резолюциянын түрү',
    RESOLUTIONS: 'Резолюциялар',
    RESPONSIBLE: 'Жооптуу',
    RESPONSIBLE_SHORT: 'Ж',
    RESTORE: 'Калыбына келтирүү',
    RESTORING_THE_PROFILE: 'Профильди калыбына келтирүү',
    RETURN: 'Кайтаруу',
    RETURN_ADDITIONAL_AGREEMENT_TO_REWORK: 'Кошумча келишимди кайра карап чыгуу үчүн кайтарыңыз',
    RETURN_APPLICATION_TO_REWORK: 'Өтүнмөнү кайра карап чыгууга кайтаруу',
    RETURN_APPLICATION_SECTIONS_TO_REWORK: 'Токтомду кайра карап чыгууга кайтаруу',
    RETURN_DOCUMENT: 'Кайра карап чыгуу үчүн кайтаруу',
    RETURN_TO_MAIN_PAGE: 'Башкы бетке кайтуу',
    RETURNED_FOR_REVISION: 'Кайра карап чыгуу үчүн кайтарылды',
    RETURNED_THE_APPLICATION_TO_REWORK: '<span class="font-medium">:author</span> арызды кайра карап чыгууга кайтарды',
    RETURNED_TO_REWORK_THE_RESOLUTION: '<span class="font-medium">:author</span> токтомду кайра карап чыгууга кайтарды',
    ROLE: 'Роль',
    ROLES: 'Ролдор',
    ROUTES: 'Маршруттар',
    RU: 'RU',
    RUSSIAN: 'Орусча',
    SAVE: 'Сактоо',
    SEARCH: 'Издөө',
    SECTION: 'Бөлүм',
    SECTION_FILES: 'Бөлүм файлдары',
    SECTIONS: 'Бөлүмдөр',
    SELECT_AGREEDS: 'Бекитүүчүлөрдү тандаңыз',
    SELECT_ALL: 'Баарын танда',
    SELECT_EXECUTORS: 'Аткаруучуларды тандоо',
    SELECT_FROM_OPTIONS: 'Тизмеден тандаңыз',
    SELECTED_EXECUTORS: 'Тандалган аткаруучулар',
    SEND: 'Жөнөтүү',
    SEND_DATE: 'Жөнөтүү күнү',
    SEND_DATE_FROM: 'Жөнөтүү күнү (баштап)',
    SEND_DATE_TO: 'Жөнөтүү күнү (чейин)',
    SEND_FOR_REVISION: 'Кайра карап чыгууга тапшырыңыз',
    SEND_LINK_TO_EMAIL: 'Шилтемени электрондук почтага жөнөтүү',
    SEND_REMARKS_TO_EXPERTIZE: 'Комментарийлерди карап чыгууга тапшырыңыз',
    SEND_TO_EXPERTIZE: 'Экспертизага тапшырыңыз',
    SENT_CHANGE_REQUEST: 'Өзгөртүү өтүнүчү жөнөтүлдү',
    SENT_THE_CONCLUSION_OF_THE_APPLICATION_TO_THE_APPLICANT: '<span class="font-medium">:author</span> арыздын токтомун арыз ээсине жөнөттү',
    SERIAL_NUMBER: 'Сериялык саны',
    SERIES: 'Серия',
    SHORT_DENOMINATION: 'Кыска аты',
    SHOW_FILE: 'Файлды көрсөт',
    SIGN: 'Кол коюу',
    SIGNER: 'Кол коюучу',
    SIGN_ADDITIONAL_AGREEMENT: 'Кошумча келишимге кол коюу',
    SIGN_AGREEMENT: 'Келишимге кол коюу',
    SIGN_ALL: 'Баарына кол коюңуз',
    SIGN_ALL_DOCUMENTS: 'Бардык документтерге кол коюу',
    SIGN_CONCLUSION: 'Корутундуга кол коюу',
    SIGN_DATE: 'Кол коюу датасы',
    SIGN_DOCUMENT: 'Документке кол коюу',
    SIGN_IN: 'Кирүү',
    SIGN_PAYMENT: 'Төлөмгө кол коюу',
    SIGN_REMARK: 'Эскертүүгө кол коюу',
    SIGN_RESOLUTION_ANSWER: 'Резолюциянын жообуна кол коюу',
    SIGN_AN_INVOICE_FOR_PAYMENT: 'Төлөм үчүн эсеп-дүмүрчөккө кол коюу',
    SIGNATURE: 'Кол коюу',
    SIGNED_BY: 'Кол койгон',
    SIGNED_DATE: 'Кол коюлган күн',
    SIGNED_THE_RESOLUTION: '<span class="font-medium">:author</span> токтомго кол койду',
    SIGNED_THE_RESOLUTION_ANSWER: '<span class="font-medium">:author</span> токтомдун жообуна кол койду',
    SIGNED_THE_RESOLUTION_CONCLUSION: '<span class="font-medium">:author</span> токтомдун корутундусуна кол койду',
    SIGNED_THE_RESOLUTION_REMARKS: '<span class="font-medium">:author</span> токтомдун эскертүүлөрүнө кол койду',
    SINGLE_WINDOW: 'Бирдиктүү терезе',
    SOM: 'сом',
    STATE: 'Госорган',
    STATE_BUDGET: 'Мамлекеттик бюджет',
    STATUS: 'Статус',
    STATUSES: 'Статустар',
    STREET: 'Көчө',
    SUB_DIRECTOR: 'Директордун орун басары',
    SUBDIVISION: 'Бөлүм',
    SUBDIVISIONS: 'Бөлүмдөр',
    SUBMIT: 'Ырастоо',
    SUBSCRIBE_TO_TELEGRAM_BOT: 'Телеграм ботуна жазылыңыз',
    SUCCESS_ACTION: 'Ийгиликтүү иш-аракет!',
    SUM: 'Сумма',
    SUPPLEMENT: 'Колдонмо',
    SURNAME: 'Фамилия',
    SWITCH_LANGUAGE: 'Тилди которуу',
    TAX_AUTHORITY_CODE: 'Салык органынын коду',
    TAX_AUTHORITY_DISTRICT: 'Райондук салык органы',
    TELEGRAM_USER_ID: 'Телеграм "user ID"',
    TELEPHONE: 'Уюлдук телефон',
    TITLE: 'Аталышы',
    TITLE_KG: 'Аталышы (kg)',
    TITLE_RU: 'Аталышы (ru)',
    TO_CANCEL: 'Жокко чыгаруу',
    TO_CONFIRM: 'Тастыктоо үчүн',
    TO_LOGIN: 'Кирүү',
    TO_ME: 'Мага',
    TO_REGISTER: 'Каттоо',
    TO_RESOLUTION: 'Резолюцияда',
    TOTAL_AMOUNT: 'Жалпы сумма',
    TYPE: 'Түрү',
    TYPE_EXPERTIZE: 'Экспертизанын түрү',
    TYPE_OF_APPLICANT: 'Өтүнмө ээсинин түрү',
    TYPES: 'Түрлөрү',
    UCHNUM: 'Участок номери',
    UGNS_KKN: 'УГНС по ККН',
    UNIT_NAME: 'Бөлүмдүн аталышы',
    UNIT_OF_MEASUREMENT: 'Өлчөө бирдиги',
    UPDATE: 'Жаңылоо',
    UPLOAD_DATE: 'Жүктөө датасы',
    USER_NOT_FOUND: 'Колдонуучу табылган жок',
    USERNAME: 'Колдонуучунун аты',
    USERS: 'Колдонуучулар',
    VALIDATION_DATE: 'Дата талаптарга дал келбейт.',
    VALUE: 'Мааниси',
    VERSION: 'Версия',
    VERSIONS: 'Версиялар',
    VILLAGE: 'Айыл',
    WAITING_YOUR_ACTIONS: 'Сиздин аракеттериңиз күтүлөт',
    WAITING_PAYMENT_CALCULATION: 'Төлөмдү эсептөөнү күтүп жатабыз',
    WAITING_REGISTRATION: 'Каттоо күтүүдө',
    WAITING_SEND_TO_APPLICANT: 'Жөнөтүүнү күтүүдө',
    WHEN_ISSUED: 'Качан чыгарылган',
    WHOOPS_SOMETHING_WENT_WRONG: 'Ой, бир жерден ката кетти окшойт!',
    WORK_PHONE: 'Жумуш телефону',
    WORKING_MODE: 'Иштөө режими',
    WROTE_REMARKS_TO_THE_RESOLUTION: '<span class="font-medium">:author</span> токтомго эскертүү жазды',
    YES: 'Ооба',
    YOU_CURATOR: 'Сиз кураторсуз',
    YOU_RESPONSIBLE: 'Сиз "Ж" аткаруучусусуз',
}
